import { FormManager } from '@visto-tech/forms';
import { Button } from 'elements/Button';
import ConfirmModal from 'elements/Modal/ConfirmModal';
import { Text } from 'elements/Text';
import { observer } from 'mobx-react-lite';
import React, { FC } from 'react';

export const FormSubmitModal: FC<{
  formManager: FormManager<any>;
  isModalOpen: boolean;
  setIsModalOpen: (status: boolean) => void;
  formName: string;
}> = observer(
  ({ formManager, isModalOpen, setIsModalOpen, formName, children }) => {
    return (
      <ConfirmModal
        modalOpen={isModalOpen}
        setModalOpen={setIsModalOpen}
        title={formManager.hasErrors() ? 'Your form has errors' : 'Submit Form'}
        image={formManager.hasErrors() ? 'magnify' : 'browserUi'}
        closeCta={formManager.hasErrors() ? 'Close' : 'Cancel'}
        className={formManager.hasErrors() ? 'border-4 border-red-700' : ''}
      >
        {formManager.hasErrors() ? (
          <>
            <Text.Paragraph className="text-center mb-6">
              Please close the pop-up and fix your errors before submitting the
              form.
            </Text.Paragraph>
            <div className="flex justify-center items-center">
              <Button
                className="fs14"
                type="button"
                onClick={() => {
                  setIsModalOpen(false);

                  if (formManager.hasErrors()) {
                    (document as Document)
                      .querySelector(`.mt-1.text-red-600.fs12`)
                      ?.scrollIntoView({
                        behavior: 'smooth',
                      });
                  }
                }}
                format="outline"
              >
                Fix Errors
              </Button>
            </div>
          </>
        ) : (
          <div>
            {children}
            <div className="flex justify-center items-center">
              <Button
                isLoading={formManager.isSubmitting}
                disabled={formManager.isSubmitting}
                value="PUBLISHED"
                className="fs14"
                type="submit"
                form={`form-${formName}`}
                size="large"
              >
                Submit
              </Button>
            </div>
          </div>
        )}
      </ConfirmModal>
    );
  }
);
